import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_ALERTS_DETAILS = "../alerts_details";
export const REDIRECT_TO_MONITORING_ALERTS_OVERVIEW = "/health/alerts_overview";
export const REDIRECT_TO_MONITORING_ALERTS_DETAILS = "/health/alerts_details";
export const REDIRECT_TO_RESOURCE_HEALTH = "/health/resource_health";
export const REDIRECT_TO_PERFORMANCE = "/health/performance_overview";

export const healthPages = {
  id: "Health",
  label: "Health",
  icon: "monitoringApp",
  items: [
    {
      label: "Alerts",
      path: "/health/alerts_overview",
      requireClientSelection: true,
      topNavLinks: [
        {
          label: "Overview",
          path: "/health/alerts_overview",
          requireClientSelection: true,
          permissions: {
            subject: Subjects.Alerts_Dashboard,
            role: Roles.Read,
          },
        },
        {
          label: "Details",
          path: "/health/alerts_details",
          requireClientSelection: true,
          permissions: {
            subject: Subjects.Alerts_Dashboard,
            role: Roles.Read,
          },
        },
      ],
    },
    {
      label: "Resource Health",
      path: "/health/resource_health",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Metrics_Dashboard,
        role: Roles.Read,
      },
    },
    {
      label: "Capacity Planning",
      path: "/health/capacity_planning",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Metrics_Dashboard,
        role: Roles.Read,
      },
    },
    {
      label: "Performance Metrics",
      path: "/health/performance_overview",
      requireClientSelection: true,
      permissions: {
        subject: Subjects.Metrics_Dashboard,
        role: Roles.Read,
      },
    },
  ],
};
